import React from "react";
import { useSelector } from "react-redux";
import HandsonTable from "../../../../../components/handsonTable/handsonTable";

const Table = () => {
  const {
    data = [],
    colHeaders = [],
    columns = []
  } = useSelector((state) => state.firstVisitConversion.conversionInfo);

  return data.length ? (
    <HandsonTable
      data={data}
      colHeaders={colHeaders}
      columns={columns}
      width={820}
      height={500}
      colWidths={[325, 100, 125, 125, 125]}
      columnSorting
    />
  ) : (
    <p className="error">No data found for selected date.</p>
  );
};

export default Table;
